import React, { PropsWithChildren } from 'react';
import { RouteProps } from 'react-router-dom';

import { useGetIsUserPermittedTo, Feature } from '@occc/utils-access-control';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type ProtectedRouteProps = RouteProps & {
  feature: Feature | Feature[];
  fallback?: React.ReactNode;
};

const getIsUserPermittedToViewRoute = (
  feature: Feature | Feature[],
  isUserPermittedTo: (feature: Feature) => boolean,
) => {
  const isArrayOfFeatures = Array.isArray(feature);

  if (isArrayOfFeatures) {
    const permittedActions = feature.filter((item) => isUserPermittedTo(item));
    return permittedActions.length > 0;
  }

  return isUserPermittedTo(feature);
};

export const ProtectedRoute: React.FC<PropsWithChildren<ProtectedRouteProps>> = ({
  feature,
  fallback,
  children,
}) => {
  const isUserPermittedTo = useGetIsUserPermittedTo();
  const isUserPermittedToViewRoute = getIsUserPermittedToViewRoute(feature, isUserPermittedTo);

  if (!isUserPermittedToViewRoute) {
    return fallback ? <>{fallback}</> : <UnauthorizedPage />;
  }

  return <>{children}</>;
};
